<div *ngFor="let notification of notificationList; let i = index" (click)="markNotificationAsRead(notification.id_notification, i)">
  <div class="divider"></div>
  <div class="hover-bg">
    <div class="d-flex">
      <div class="wrapper">
        <img class="icon rounded-circle" [src]="notification?.source_user?.thumbnail | authImage | async">
        <div class="badge" *ngIf="!notification?.already_read"></div>
      </div>
      <div class="description-container">
        <span>{{notification?.description}}</span>
      </div>
    </div>
    <div class="description-footer-container">
      <span class="space">{{notification?.notification_Timestamp * 1000 | timeAgo}}</span>
      <span>{{notification?.project_name ? notification?.workspace_name + ' > ' + notification?.project_name : notification?.workspace_name}}</span>
    </div>
  </div>
  <div class="divider" *ngIf="i === notificationList.length - 1"></div>
</div>
<!--TODO divider top and bottom-->
